import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Tooltip, Dialog, Typography, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from '@mui/material';
import * as Icons from '@mui/icons-material';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useManageDocQuery } from '../../../hooks/useManageDocQuery';
import { Close } from '@mui/icons-material';
import { DownloadFile } from '../../others/DownloadFile';
import { GetHistoryDoc } from '../../../redux/actions/docQuery';
import { useTranslation } from 'react-i18next';
import { ActionIconItem } from '../../others/ActionIconItem';

export const ModalHistory = ({ data, idReception }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [DocManager] = useManageDocQuery();
    const {
        historyDoc
    } = DocManager;
    const [{ userSession }] = useDataAuth();
    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <ActionIconItem
                item={data}
                onClick={() => {
                    dispatch(GetHistoryDoc(userSession.token, idReception));
                    setOpen(true);
                }}
                defaultIcon="ManageSearch"
            />

            <Dialog
                open={open}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    style: { height: '80%' },
                }}
            >
                <DialogTitle>
                    <Typography variant="h5" component="h5">
                        {t("documentHistory")}
                    </Typography>

                    <IconButton
                        aria-label="close"
                        onClick={() => setOpen(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Estado</TableCell>
                                <TableCell>Fecha</TableCell>
                                <TableCell>Información estado</TableCell>
                                <TableCell>Descripción</TableCell>
                                <TableCell>Adjuntos</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                historyDoc.map((item) => (
                                    <TableRow>
                                        <TableCell>{item.status}</TableCell>
                                        <TableCell>{item.created}</TableCell>
                                        <TableCell>{item.info_status}</TableCell>
                                        <TableCell>{item.description}</TableCell>
                                        <TableCell>
                                            <Typography>
                                                <DownloadFile path={item.path} bucket={item.bucket} />
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}